export default {
    props: {
        contentColor: {
            type: String,
            default: undefined,
            kComposite: 'content.color'
        }, 
        contentFontFamily: {
            type: String,
            default: undefined,
            kComposite: 'content.fontFamily'
        }, 
        contentFontSize: {
            type: Number,
            default: undefined,
            kComposite: 'content.fontSize'
        }, 
        contentFontStyle: {
            type: String,
            default: undefined,
            kComposite: 'content.fontStyle'
        }, 
        contentFontWeight: {
            type: String,
            default: undefined,
            kComposite: 'content.fontWeight'
        }, 
        contentTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'content.template'
        }, 
        contentText: {
            type: String,
            default: undefined,
            kComposite: 'content.text'
        }, 
        contentVisual: {
            type: Function,
            default: undefined,
            kComposite: 'content.visual'
        }, 
        editable: {
            type: Boolean,
            default: undefined,
            kComposite: 'editable'
        }, 
        editableTools: {
            type: Array,
            default: undefined,
            kComposite: 'editable.tools'
        },
        endCap: {
            type: String,
            default: undefined,
            kComposite: 'endCap'
        }, 
        endCapFill: {
            type: String,
            default: undefined,
            kComposite: 'endCap.fill'
        }, 
        endCapFillColor: {
            type: String,
            default: undefined,
            kComposite: 'endCap.fill.color'
        }, 
        endCapStroke: {
            type: String,
            default: undefined,
            kComposite: 'endCap.stroke'
        }, 
        endCapStrokeColor: {
            type: String,
            default: undefined,
            kComposite: 'endCap.stroke.color'
        }, 
        endCapStrokeDashType: {
            type: String,
            default: undefined,
            kComposite: 'endCap.stroke.dashType'
        }, 
        endCapStrokeWidth: {
            type: Number,
            default: undefined,
            kComposite: 'endCap.stroke.width'
        }, 
        endCapType: {
            type: String,
            default: undefined,
            kComposite: 'endCap.type'
        }, 
        from: {
            type: [String, Number],
            default: undefined,
            kComposite: 'from'
        }, 
        fromX: {
            type: Number,
            default: undefined,
            kComposite: 'from.x'
        }, 
        fromY: {
            type: Number,
            default: undefined,
            kComposite: 'from.y'
        }, 
        fromConnector: {
            type: String,
            default: undefined,
            kComposite: 'fromConnector'
        }, 
        hoverStrokeColor: {
            type: String,
            default: undefined,
            kComposite: 'hover.stroke.color'
        }, 
        points: {
            type: Array,
            default: undefined,
            kComposite: 'points'
        },
        selectionHandlesFill: {
            type: String,
            default: undefined,
            kComposite: 'selection.handles.fill'
        }, 
        selectionHandlesFillColor: {
            type: String,
            default: undefined,
            kComposite: 'selection.handles.fill.color'
        }, 
        selectionHandlesStrokeColor: {
            type: String,
            default: undefined,
            kComposite: 'selection.handles.stroke.color'
        }, 
        selectionHandlesWidth: {
            type: Number,
            default: undefined,
            kComposite: 'selection.handles.width'
        }, 
        selectionHandlesHeight: {
            type: Number,
            default: undefined,
            kComposite: 'selection.handles.height'
        }, 
        startCap: {
            type: String,
            default: undefined,
            kComposite: 'startCap'
        }, 
        startCapFill: {
            type: String,
            default: undefined,
            kComposite: 'startCap.fill'
        }, 
        startCapFillColor: {
            type: String,
            default: undefined,
            kComposite: 'startCap.fill.color'
        }, 
        startCapStroke: {
            type: String,
            default: undefined,
            kComposite: 'startCap.stroke'
        }, 
        startCapStrokeColor: {
            type: String,
            default: undefined,
            kComposite: 'startCap.stroke.color'
        }, 
        startCapStrokeDashType: {
            type: String,
            default: undefined,
            kComposite: 'startCap.stroke.dashType'
        }, 
        startCapStrokeWidth: {
            type: Number,
            default: undefined,
            kComposite: 'startCap.stroke.width'
        }, 
        startCapType: {
            type: String,
            default: undefined,
            kComposite: 'startCap.type'
        }, 
        strokeColor: {
            type: String,
            default: undefined,
            kComposite: 'stroke.color'
        }, 
        strokeWidth: {
            type: Number,
            default: undefined,
            kComposite: 'stroke.width'
        }, 
        to: {
            type: [String, Number],
            default: undefined,
            kComposite: 'to'
        }, 
        toX: {
            type: Number,
            default: undefined,
            kComposite: 'to.x'
        }, 
        toY: {
            type: Number,
            default: undefined,
            kComposite: 'to.y'
        }, 
        toConnector: {
            type: String,
            default: undefined,
            kComposite: 'toConnector'
        }, 
        type: {
            type: String,
            default: undefined,
            kComposite: 'type'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-diagram-vue-wrapper/src/KendoDiagramConnection/ConnectionProps.js